/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesTenantsDtosCreateTenantRequest,
  FacilityFlowCoreModulesTenantsDtosTenantDto,
  FacilityFlowCoreModulesTenantsDtosTenantStatisticsDto,
  FacilityFlowCoreModulesTenantsDtosUpdateTenantRequest,
  FacilityFlowCoreModulesTenantsWorkflowsChangeTenantPlanRequest,
  FacilityFlowCoreModulesTenantsWorkflowsCreateTenantWorkflowResponse
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTenants = () => {
/**
 * @summary Get all tenants
 */
const getApiV1Tenants = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto[]>(
      {url: `/api/v1/tenants`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Create a new tenant
 */
const postApiV1Tenants = (
    facilityFlowCoreModulesTenantsDtosCreateTenantRequest: FacilityFlowCoreModulesTenantsDtosCreateTenantRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantsWorkflowsCreateTenantWorkflowResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantsWorkflowsCreateTenantWorkflowResponse>(
      {url: `/api/v1/tenants`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesTenantsDtosCreateTenantRequest
    },
      options);
    }
  /**
 * @summary Get current tenant information
 */
const getApiV1TenantsCurrent = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto>(
      {url: `/api/v1/tenants/current`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Get tenant by ID
 */
const getApiV1TenantsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto>(
      {url: `/api/v1/tenants/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing tenant
 */
const putApiV1TenantsId = (
    id: string,
    facilityFlowCoreModulesTenantsDtosUpdateTenantRequest: FacilityFlowCoreModulesTenantsDtosUpdateTenantRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto>(
      {url: `/api/v1/tenants/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesTenantsDtosUpdateTenantRequest
    },
      options);
    }
  /**
 * @summary Deactivate a tenant
 */
const patchApiV1TenantsIdDeactivate = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tenants/${id}/deactivate`, method: 'PATCH'
    },
      options);
    }
  /**
 * @summary Activate a tenant (re-enable a deactivated account).
 */
const patchApiV1TenantsIdActivate = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tenants/${id}/activate`, method: 'PATCH'
    },
      options);
    }
  /**
 * @summary Change the tenant's subscription plan. Triggers proration billing by default.
 */
const patchApiV1TenantsIdPlan = (
    id: string,
    facilityFlowCoreModulesTenantsWorkflowsChangeTenantPlanRequest: FacilityFlowCoreModulesTenantsWorkflowsChangeTenantPlanRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantsDtosTenantDto>(
      {url: `/api/v1/tenants/${id}/plan`, method: 'PATCH',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesTenantsWorkflowsChangeTenantPlanRequest
    },
      options);
    }
  /**
 * @summary Aggregated usage statistics for a tenant (employees, customers, objects, invoices, etc.).
 */
const getApiV1TenantsIdStatistics = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantsDtosTenantStatisticsDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantsDtosTenantStatisticsDto>(
      {url: `/api/v1/tenants/${id}/statistics`, method: 'GET'
    },
      options);
    }
  return {getApiV1Tenants,postApiV1Tenants,getApiV1TenantsCurrent,getApiV1TenantsId,putApiV1TenantsId,patchApiV1TenantsIdDeactivate,patchApiV1TenantsIdActivate,patchApiV1TenantsIdPlan,getApiV1TenantsIdStatistics}};
export type GetApiV1TenantsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['getApiV1Tenants']>>>
export type PostApiV1TenantsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['postApiV1Tenants']>>>
export type GetApiV1TenantsCurrentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['getApiV1TenantsCurrent']>>>
export type GetApiV1TenantsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['getApiV1TenantsId']>>>
export type PutApiV1TenantsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['putApiV1TenantsId']>>>
export type PatchApiV1TenantsIdDeactivateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['patchApiV1TenantsIdDeactivate']>>>
export type PatchApiV1TenantsIdActivateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['patchApiV1TenantsIdActivate']>>>
export type PatchApiV1TenantsIdPlanResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['patchApiV1TenantsIdPlan']>>>
export type GetApiV1TenantsIdStatisticsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenants>['getApiV1TenantsIdStatistics']>>>
